import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FormControl, FormHelperText, Typography, Chip } from '@material-ui/core';
import useIsFieldRequired from '../../../utility/useIsFieldRequired';

const RMSChipSelector = ({
  name,
  label,
  options = [], // options => variant ('primary', 'success', 'warning', 'danger')
  multiple = false,
  disabled = false,
  direction = 'row',
  onChange,
}) => {
  const { control } = useFormContext();

  const isSelected = (value, optionValue) => {
    if (multiple) {
      return Array.isArray(value) && value.includes(optionValue);
    }

    return value === optionValue;
  };

  const handleSelection = (field, optionValue) => {
    if (disabled) return;
    let selectedValue;

    if (multiple) {
      const values = Array.isArray(field.value) ? [...field.value] : [];

      const index = values.indexOf(optionValue);

      if (index > -1) {
        values.splice(index, 1);
      } else {
        values.push(optionValue);
      }

      field.onChange(values);
      selectedValue = values;
      const selectedOptions = options.filter((o) => selectedValue.includes(o.value));
      onChange?.({
        value: selectedValue,
        options: selectedOptions,
      });
    } else {
      field.onChange(optionValue);
      selectedValue = optionValue;
      onChange?.({
        value: selectedValue,
        option: options.find((o) => o.value === optionValue),
      });
    }
  };

  const isRequired = useIsFieldRequired(name);

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={multiple ? [] : ''}
      render={({ field, fieldState: { error } }) => (
        <FormControl fullWidth error={!!error} disabled={disabled}>
          {label && (
            <Typography className="rms-chip-selector__label mb-1">
              {label}
              {isRequired && <span className="rms-chip-selector__required">*</span>}
            </Typography>
          )}

          <div className={`rms-chip-selector__group rms-chip-selector__group--${direction}`}>
            {options.map((option) => {
              const selected = isSelected(field.value, option.value);

              return (
                <Chip
                  key={option.value}
                  label={option.label}
                  clickable={!option.disabled}
                  disabled={option.disabled}
                  onClick={() => handleSelection(field, option.value)}
                  className={`
                      rms-chip-selector__chip
                      rms-chip-selector__chip--${option.variant ?? 'primary'}
                      ${selected ? 'rms-chip-selector__chip--selected' : ''}
                      `}
                  variant={selected ? 'default' : 'outlined'}
                />
              );
            })}
          </div>

          {error && <FormHelperText className="mt-2">{error.message}</FormHelperText>}
        </FormControl>
      )}
    />
  );
};

export default RMSChipSelector;
